//@flow
import { handleMutationError } from "../API"
import type { CreateSlideMutation, UpdateSlideMutation, Slide } from "./types"

const stripTypename = (obj: Object): Object => {
  const { __typename, mediaURL, id, ...rest } = obj
  return rest
}

const stripSlideData = (slide: Slide): Slide => ({
  ...stripTypename(slide),
  localizedHeadlineText: stripTypename(slide.localizedHeadlineText),
  localizedSecondaryText: stripTypename(slide.localizedSecondaryText)
})

const handleSubmit = (
  attractLoopId: string,
  id: ?string,
  createSlide: CreateSlideMutation,
  updateSlide: UpdateSlideMutation,
  onSuccess: Function
) => async (slide: Slide) => {
  try {
    const { id } = slide
    const slideInput = stripSlideData(slide)
    await (typeof id === "string"
      ? updateSlide(attractLoopId, id, slideInput)
      : createSlide(attractLoopId, slide))
    onSuccess()
  } catch (mutationError) {
    const errorString: string = mutationError
    handleMutationError(errorString)
  }
}

export default handleSubmit



// WEBPACK FOOTER //
// ./src/Slides/handleSubmit.js